function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Nivea_Logo",
  "data-name": "Nivea Logo",
  transform: "translate(0.75 0.75)"
}, React.createElement("path", {
  id: "Outline",
  d: "M328.964,196.149a40,40,0,1,1-40-40,40,40,0,0,1,40,40Z",
  transform: "translate(-248.964 -156.149)",
  fill: "none",
  stroke: "#050c1a",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), React.createElement("path", {
  id: "Text",
  d: "M-7686.738-2697.722v5.087h-4.3v-14.125l6.975,6.072v-5.079h4.295v14.108Zm15.847-8.046h4.577s2.7,5.474,2.933,5.885l2.943-5.885h4.576c.017,0-7.52,14.108-7.52,14.108Zm15.735,13.131v-13.131h8.412v3.332h-4.128v1.841l4.128,0v2.488h-4.128v2.043h4.128v3.429Zm-20.73,0v-13.131s4.294.015,4.294,0v13.131Zm41.481,0-.708-1.428h-5.358l-.729,1.428h-4.486s5.238-9.514,7.9-14.21l7.9,14.21Zm-1.772-3.6s-1.608-3.367-1.608-3.367-1.639,3.364-1.646,3.367Z",
  transform: "translate(7701.445 2739.253)",
  fill: "#050c1a"
}));

var SvgLogoNivea = function SvgLogoNivea(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 81.5,
    height: 81.5,
    viewBox: "0 0 81.5 81.5",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoNivea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-nivea.17ab650f.svg";
export { ForwardRef as ReactComponent };